import Button from "./Button";
export  default  Button



// WEBPACK FOOTER //
// ./components/Cc-Button/index.js